document.addEventListener('DOMContentLoaded', event => {    
    let hasAddedUnitChoice = false;
    let chosen_unit = 'in';
    var cts_app = document.querySelectorAll('html')[0]._x_dataStack[0];

    // PO Number / Cart Attributes support
    window.updateCartAttribute = async function(name, value) {
        if (!cts_app) return;
        cts_app.cart_loading = true;
        try {
            const response = await fetch(
                `${window.Shopify.routes.root}cart/update.js`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: { [name]: value } })
                }
            );
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.description || 'Failed to update cart attribute');
            }
        } catch (error) {
            console.error('Error updating cart attribute:', error);
        } finally {
            cts_app.cart_loading = false;
        }
    };

    // Refresh cart on pageshow (back / forward) fix for Edge
    window.addEventListener('pageshow', (e) => {
        if (cts_app) {
            cts_app.updateCart(false);            
        }
    });    
    document.addEventListener('Searchanise.Loaded', function(event, input, container) {
        
        (function ($) {         
            /* Replaces description with specs meta value if specs exists */
            $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
                // console.log('datarequestend',data);
                data.items.forEach((d)=>d.description = d.metafield_890876f17d8f280fff23283fe46f6524?.split('|').join('<br>') || d.description);
            });        

            $(document).on('Searchanise.AddToCartSuccess', function(event, add_to_cart_id, product) {
                cts_app.updateCart(true);
            });            
            
            let seal_range_filter_in, seal_range_filter_mm, has_seal_range_filter;
            let outer_seal_range_filter_in, outer_seal_range_filter_mm, has_outer_seal_range_filter;

            function showUnitSelection(e) {
                if(e.target.value == "in"){
                    seal_range_filter_in?.style.setProperty('display', 'block', 'important');
                    seal_range_filter_mm?.style.setProperty('display', 'none', 'important');

                    outer_seal_range_filter_in?.style.setProperty('display', 'block', 'important');
                    outer_seal_range_filter_mm?.style.setProperty('display', 'none', 'important');

                    chosen_unit = 'in';
                } else {
                    seal_range_filter_in?.style.setProperty('display', 'none', 'important');
                    seal_range_filter_mm?.style.setProperty('display', 'block', 'important');

                    outer_seal_range_filter_in?.style.setProperty('display', 'none', 'important');
                    outer_seal_range_filter_mm?.style.setProperty('display', 'block', 'important');

                    chosen_unit = 'mm';
                }
            }
            
            // Fires after the Search Results widget (incl. filters sidebar) finishes rendering
            $(document).on('Searchanise.ResultsUpdated', function (event, $container) {
                seal_range_filter_in = document.querySelector('#snize_filters_block_filter_metafield_5ca16f433209745ce003384917821ad9, #snize_filters_block_snize_facet4');
                seal_range_filter_mm = document.querySelector('#snize_filters_block_filter_metafield_7f9152f33fb92b8018fa5176778cd10b, #snize_filters_block_snize_facet3');
                has_seal_range_filter = seal_range_filter_in && seal_range_filter_mm;

                outer_seal_range_filter_in = document.querySelector('#snize_filters_block_filter_metafield_4900c1b0fd9c019957f152a6f79e625d');
                outer_seal_range_filter_mm = document.querySelector('#snize_filters_block_filter_metafield_6ee58cd8dcce1957900f3a5dd792c0da');
                has_outer_seal_range_filter = outer_seal_range_filter_in && outer_seal_range_filter_mm;

                if (has_seal_range_filter || has_outer_seal_range_filter) {
                    let searchResults = document.querySelector('.snize-search-results');
                    let filterSidebar = document.querySelector('.snize-filters-sidebar.snize-product-filters');

                    if(filterSidebar){
                        let unitSelection = `
                        <div style="display:inline-block;" class="snize-product-filters-title cts-units-selector">
                        <label for="sg_select_unit" class="cts-units-selector-label">Select a Sealing Range Unit:</label>
                        <select name="sg_select_unit" id="sg_select_unit">
                            <option value="in" ` + (chosen_unit == 'in' ? 'selected' : '' ) +  ` >Inches</option>
                            <option value="mm" ` + (chosen_unit == 'mm' ? 'selected' : '' ) +  ` >Millimeters</option>
                        </select>
                        </div>`;

                        let unitSelectionContainer = document.createElement('div');
                        unitSelectionContainer.classList.add('snize-product-filters-block');
                        unitSelectionContainer.innerHTML = unitSelection;
                        unitSelectionContainer.querySelector('select').onchange = showUnitSelection;

                        filterSidebar.insertBefore(unitSelectionContainer, seal_range_filter_in);
                        hasAddedUnitChoice = true;
                    }

                    if(document.querySelector('#sg_select_unit').value){
                        // Create a new change event (with bubbling if needed)
                        const changeEvent = new Event('change', { bubbles: true });

                        // Dispatch the change event on the input element
                        document.querySelector('#sg_select_unit').dispatchEvent(changeEvent);
                    }
                }
            });
        })(window.Searchanise.$);
    });
});
//var app = document.querySelectorAll('html')[0]._x_dataStack[0];
